import { ComponentType } from 'react';

import cn from 'classnames';

export interface TextAlertProps {
	id?: string;
	renderIcon: ComponentType<{ className?: string }>;
	testId?: string;
	text: string;
	title?: string;
	variant?: 'default' | 'primary' | 'warning' | 'danger' | 'success';
}

const TextAlert = (props: TextAlertProps) => {
	const {
		testId = 'TextAlert',
		text,
		title,
		id,
		renderIcon: Icon,
		variant = 'primary',
	} = props;

	const iconClassname = cn('h-5 lg:h-6', {
		'fill-slate-600': variant === 'default',
		'fill-sky-700': variant === 'primary',
		'fill-amber-700': variant === 'warning',
		'fill-red-700': variant === 'danger',
		'fill-lime-700': variant === 'success',
	});

	return (
		<div
			id={id}
			data-testid={testId}
			className={cn(
				'mx-auto flex max-w-156 scroll-mt-20 gap-2 rounded-xl px-4 py-3 text-sm lg:scroll-mt-30 lg:rounded-2xl lg:py-4 lg:text-base',
				{ 'bg-slate-50 text-slate-600': variant === 'default' },
				{ 'bg-sky-50 text-sky-700': variant === 'primary' },
				{ 'bg-amber-50 text-amber-700': variant === 'warning' },
				{ 'bg-red-50 text-red-700': variant === 'danger' },
				{ 'bg-lime-50 text-lime-700': variant === 'success' },
			)}
		>
			<div>
				<Icon className={iconClassname} />
			</div>
			<span>
				<span className="font-semibold">{title}</span> {text}
			</span>
		</div>
	);
};

export default TextAlert;
